import React, { useState } from "react";
import { FaArchive, FaPen } from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import PopupNewPassword from "../PopupNewPassword";
import UserPhoto from "../UserPhoto";

import "./styles.css";


export default function AdminCard(props) {
    const history = useHistory();


    return (
        <>
            <li className="admin-card-container" key={props.key}>
                <UserPhoto
                src = {props.foto}
                />
                <Link
                    to={props.linkInfo}
                >
                <b>{props.nome}</b>
                </Link>
                {
                    !props.little ?
                    <>
                        <p><b>Email: </b>{props.obj.user.email}</p>
                        <p><b>Telefone: </b>{props.obj.ddi + props.obj.telefone}</p>
                        <span><p className={props.obj.user.ativo ? "active" : "inactive"}>{props.obj.user.ativo ? "Ativo" : "Inativo"}</p></span>
                    </>
                    :
                    null
                }


                <button onClick={() => history.push(props.linkInfo)}><FaPen/></button>
                
                <button className={props.active ? 'red' : 'green'} onClick={() => props.active ? props.onDisable() : props.onActivate()}><FaArchive /></button>
                
            </li>
        </>
    )
}